import React from 'react'
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap'

const VerifierReporting = () => {
    return (
        <>
            <Row>
                <Col>
                    <Card className='mb-4'>
                        <CardHeader className='nopadbottom'>
                            <h4>IRS</h4>
                        </CardHeader>
                        <CardBody>
                            <Row className='mb-1'>
                                <Col lg={10}>
                                    <h5>IMO DCS</h5>
                                </Col>
                                <Col>
                                    <i className='dripicons-download' />
                                </Col>
                            </Row>
                            <Row className='mb-1'>
                                <Col lg={10}>
                                    <h5>EU MRV</h5>
                                </Col>
                                <Col>
                                    <i className='dripicons-download' />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={10}>
                                    <h5>Swachh Sagar</h5>
                                </Col>
                                <Col>
                                    <i className='dripicons-download' />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
                <Col>
                    <Card>
                        <CardHeader className='nopadbottom'>
                            <h4>LR</h4>
                        </CardHeader>
                        <CardBody>
                            <Row className='mb-1'>
                                <Col lg={10}>
                                    <h5>IMO DCS</h5>
                                </Col>
                                <Col>
                                    <i className='dripicons-download' />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={10}>
                                    <h5>EU MRV</h5>
                                </Col>
                                <Col>
                                    <i className='dripicons-download' />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default VerifierReporting